import {
  ScheduleContent,
  SchedulePipeline,
} from '@optools/services/operator-gateway/types/schedule';

import { AuditPipelineDetail } from './audit-pipeline-detail';

export interface AuditPipelineListProps {
  content: ScheduleContent[];
  pipelines: SchedulePipeline[];
}

export function AuditPipelineList({ content, pipelines }: AuditPipelineListProps) {
  const mappedContent = Object.fromEntries(content.map((content) => [content.mediaId, content]));

  const filteredPipelines = pipelines.filter(
    (pipeline) =>
      !!pipeline.id && pipeline.media.some(({ id }) => Object.hasOwn(mappedContent, id)),
  );

  if (!filteredPipelines.length) return null;

  return (
    <div>
      <h3 className="mb-2 w-max font-bold">Pipelines</h3>
      <ul className="isolate space-y-2">
        {filteredPipelines.map((pipeline) => {
          return (
            <li key={`${pipeline.id}-${pipeline.media}`}>
              <AuditPipelineDetail content={mappedContent} pipeline={pipeline} />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
